import { render, staticRenderFns } from "./ComissaoEntrega.vue?vue&type=template&id=1d74a750&scoped=true"
import script from "./ComissaoEntrega.vue?vue&type=script&lang=js"
export * from "./ComissaoEntrega.vue?vue&type=script&lang=js"
import style0 from "./ComissaoEntrega.vue?vue&type=style&index=0&id=1d74a750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d74a750",
  null
  
)

export default component.exports